export default __webpack_public_path__ + "static/img_product_cample@2x-1992297e0686d972eaf4484bf105fb3a.png";